// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"216":"115d9322c027fedf","573":"f760b8b4dafc3ffc","698":"6b3af0bf635a3642"}[chunkId] + ".js";
};